import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { fetchQuery } from '@sequencehq/api'
import { useCallback } from 'react'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

export type v1ApiProduct = Dashboardv20240509Api.GetProducts.Product

type UseLoadProducts = () => (props: {
  prices: { productId: string }[]
}) => Promise<{
  products: v1ApiProduct[]
}>

export const useLoadProducts: UseLoadProducts = () => {
  const load = useCallback(
    async ({ prices }: { prices: { productId: string }[] }) => {
      const allProductIds = prices
        .map(price => price.productId)
        .reduce<string[]>(
          (acc, productId) =>
            acc.includes(productId) ? acc : [...acc, productId],
          []
        )

      const products = (
        await Promise.all(
          allProductIds.map(productId =>
            fetchQuery(
              apiQueryClient,
              dashboardv20240509Client.getProduct,
              { id: productId },
              { staleTime: 10 * MINUTES }
            )
          )
        )
      ).filter((product): product is v1ApiProduct => Boolean(product))

      return {
        products
      }
    },
    []
  )

  return load
}
